<template>
  <div class="single-pin-input">
    <div
      :id="`code-block-${activeInput}`"
      class="code-block single-input"
    >
      <h3
        v-if="showNumber"
        class="font-title-3 text-ui-primary"
        :class="{ 'error-number': isError, 'empty-number': !otpInput && !isError, 'fill-number': !!otpInput && !isError }"
      >
        {{ otpInput }}
      </h3>
      <div
        v-else
        class="single-dot"
        :class="{ 'error-dot': isError, 'empty-dot': !otpInput && !isError, 'fill-dot': !!otpInput && !isError }"
      ></div>
    </div>
    <input
      :id="`pin-input-${activeInput}`"
      class="font-body-1-new pin-input single-input"
      :class="{ 'error': isError, 'empty': !otpInput && !isError, 'filled': !!otpInput && !isError }"
      maxlength="1"
      v-model="otpInput"
      autocomplete="off"
      type="tel"
      ref="otpinput"
      @focus="$emit('focus', activeInput)"
      @keydown="e => handleKeyDown(e)"
      @paste="handleOnPaste($event)"
      @keypress="isNumericOnlyMixin"
    />
  </div>
</template>

<script>
import inputHelperMixin from '@/mixins/inputHelper.js'

export default {
  name: 'SingleOtpInput',
  mixins: [inputHelperMixin],
  props: {
    activeInput: {
      type: [String, Number]
    },
    value: {
      type: [String, Number]
    },
    isError: {
      type: Boolean,
      default: false
    },
    showNumber: {
      type: Boolean,
      default: false
    },
    maxInput: {
      type: Number
    }
  },
  computed: {
    otpInput: {
      get () {
        return this.value
      },
      set (value) {
        this.handleOtpInput(value)
      }
    }
  },
  methods: {
    handleOtpInput (value) {
      this.$emit('onChange', { key: this.activeInput, value })
      if (this.activeInput < this.maxInput) this.$emit('focusNext', this.activeInput)
    },
    handleKeyDown (e) {
      const BACKSPACE = 8
      const LEFT_ARROW = 37
      const RIGHT_ARROW = 39
      const SPACE = 32

      switch (Number(e.keyCode)) {
        case BACKSPACE:
          const key = Math.max(Number(this.activeInput) - 1, 0)
          this.$emit('prevInput', { key })
          return e.preventDefault()
        case LEFT_ARROW:
          this.$emit('focusPrevious', this.activeInput)
          break
        case RIGHT_ARROW:
          this.$emit('focusNext', this.activeInput)
          break
        case SPACE:
          e.preventDefault()
          break
        default:
          break
      }
    },
    handleOnPaste (e) {
      this.$emit('pasteInput', e)
    }
  }
}
</script>

<style scoped>
.single-pin-input {
  position: relative;
}
.single-input {
  border: none;
  border-radius: 0;
  width: 28px;
  height: 40px;
}

.pin-input:has(> .error),
.single-input:has(> .error-number),
.single-input:has(> .error-dot) {
  border-bottom: 2px solid var(--color-crimson-500);
}

.pin-input:has(> .empty),
.single-input:has(> .empty-number),
.single-input:has(> .empty-dot) {
  border-bottom: 2px solid var(--color-ui-element-grey-5);
}

.pin-input:focus,
.pin-input:focus + .code-block,
.pin-input:has(> .filled),
.single-input:has(> .fill-number),
.single-input:has(> .fill-dot) {
  border-bottom: 2px solid var(--color-royal-navy-500);
}

.single-input:not(:focus) + .pin-input {
  color: transparent;
}

.single-dot {
  height: 12px;
  width: 12px;
  border-radius: 50%;
  display: inline-block;
}

.error-dot,
.empty-dot {
  border: 1px solid var(--color-neutral-700);
  background-color: var(--color-neutral-100);
}

.fill-dot {
  border: 1px solid var(--color-royal-navy-500);
  background-color: var(--color-royal-navy-500);
}

.pin-input {
  position: relative;
  z-index: 2;
  display: flex;
  padding: 12px 8px;
  justify-content: center;
  align-items: center;
  gap: 10px;
  text-align: center;
  background-color: transparent;
  color: var(--color-ui-text-primary);
}

.code-block {
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
}

.pin-input::before {
  width: 12px;
  height: 12px;
  flex-shrink: 0;
  stroke-width: 1px;
  stroke: var(--color-neutral-700);
}

.pin-input:focus {
  outline: none;
  box-shadow: none;
  caret-color: transparent;
}
</style>
